/**
 *  Module for pricing and availability for Asia.
 */

const Availability = function (app) {

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    $ = require('jquery');

  function checkProductOverrides({ data = [] }) {
    if (data === null) {
      data = [];
    }

    app.performance.mark('configure:ola:loaded');

    if (!app.mergedParams.currency) {
      app.mergedParams.currency = configure.run('getCurrency');
    }

    const productOverrides = {
      debug: false,
      values: {},
      renderInactive: {
        style_fit_and_size: true,
        style_fit_color_and_size: true
      }
    };

    let omit = [];
    // const localeFacetFilter = app.mergedParams.facetFilters.filter(facetFilter => facetFilter.facet === 'locale')[0].facetValue.toLowerCase();
    const size = configure.run('getAttribute', { alias: 'size' });
    const values = size.values;

    // First create to the object with all the values deactivated.
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      const id = value.vendorId;

      productOverrides.values[id] = { valueUsages: {} };
      productOverrides.values[id].valueUsages[id] = { active: false };
    }

    // For internal testing. Add the ability to omit values and test
    // the On-Load Availability features. Pass a comma separated
    // e.g. &omitValues=0038703518
    const omitValues = String(app.mergedParams.omitValues);
    if (app.isFluidEnv() && omitValues) {
      if (omitValues.indexOf(',') >= 0) {
        omit = omitValues.split(',');
      } else {
        omit = [omitValues];
      }
      console.log('omit', omit);
    }

    for (const item of data) {
      if (item.upc) {
        // only available skus will be listed in data
        const omitProduct = omit.indexOf(item.upc) !== -1;

        if (!omitProduct) {
          // Only add the value if it is relevant to the current product.
          // We can find that because we first create the productOverrides with all
          // the values deactivated.
          if (productOverrides.values[item.upc] && productOverrides.values[item.upc].valueUsages[item.upc]) {
            productOverrides.values[item.upc].valueUsages[item.upc].active = true;
            productOverrides.values[item.upc].valueUsages[item.upc].upcharge = {};
            productOverrides.values[item.upc].valueUsages[item.upc].upcharge[app.mergedParams.currency] = item.price;
          }
        } else {
          const valueUsages = {};
          valueUsages[item.upc] = { active: false };
          productOverrides.values[item.upc] = {
            valueUsages
          };
        }
      }
    }
    return productOverrides;
  }

  function checkAvailability(styleNumbers, callback) {
    let url = '';
    const avail = app.mergedParams.Avail;

    const apiCn = 'https://api.ralphlauren.cn';
    const apiCnUat = 'https://ralphlauren-uat.baozun.com';
    const apiHk = 'https://www.ralphlauren.com.hk';
    const apiHkUat = 'https://ralphlauren-hk-uat.baozun.com';

    if (avail) {
      url = window.decodeURIComponent(avail);
    } else {
      const isHkLocale = app.mergedParams.requestedLocale === 'en_HK';
      url = isHkLocale ? apiHk : apiCn;

      if (app.mergedParams.workflow !== 'prod' && !app.mergedParams.forceProdOla) {
        url = isHkLocale ? apiHkUat : apiCnUat;
      }

      url += '/apis/rlp/product/list/validate/detail/validateSkus.do';
    }

    const data = JSON.stringify({ upcs: styleNumbers });

    $.ajax({
      method: 'POST',
      cache: true,
      url,
      data,
      contentType: 'application/json; charset=UTF-8'
    }).done(function (data) {
      callback(checkProductOverrides(data, styleNumbers));
    }).fail(function () {
      console.warn('Unable to load availability data.');
      callback(checkProductOverrides({}, styleNumbers));
    });
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    checkAvailability
  };
};

module.exports = Availability;
